import React from 'react'
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Home from './pages/home/Home';
import Layout from './layout/Layout'
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import './App.css'
import Notice from './pages/notice/Notice';
import Gallery from './components/gallery/Gallery';
import Organizations from './pages/organisation/Organizations';
import ShowPage from './pages/Show-content-page/ShowPage';
import Documents from './pages/documents/Documents';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <About/>,
      },
      {
        path: "/org/:idx",
        element: <Organizations/>,
      },
      {
        path: "/documents/:idx",
        element: <Documents/>,
      },
      {
        path: "/notice/:idx",
        element: <Notice/>,
      },
      {
        path: "/show-page",
        element: <ShowPage/>,
      },
      {
        path: "/gallery",
        element: <Gallery/>,
      },
      {
        path: "/contact",
        element: <Contact/>,
      },
    ],
    
  },
]);

function App() {

  return (
    <div className="app">
      <div>
        <RouterProvider router={router} />
      </div>
    </div>
  );
}

export default App;
